var exports = {
  "Qs": "CustomStatusDisplay.module__content___RVJLRl",
  "pF": "CustomStatusDisplay.module__singleLine___RVJLRl",
  "tD": "CustomStatusDisplay.module__constrained___RVJLRl",
  "IY": "CustomStatusDisplay.module__truncatedText___RVJLRl",
  "j9": "CustomStatusDisplay.module__clamped___RVJLRl",
  "H0": "CustomStatusDisplay.module__statusEmoji___RVJLRl",
  "My": "CustomStatusDisplay.module__statusEmojiWrapper___RVJLRl",
  "hb": "CustomStatusDisplay.module__staticEmoji___RVJLRl",
  "oG": "CustomStatusDisplay.module__animatedEmoji___RVJLRl",
  "kK": "CustomStatusDisplay.module__hiddenVisually___RVJLRl",
  "SA": "CustomStatusDisplay.module__jumbo___RVJLRl",
  "We": "CustomStatusDisplay.module__editableWrapper___RVJLRl",
  "Ke": "CustomStatusDisplay.module__editableTextHover___RVJLRl",
  "BW": "CustomStatusDisplay.module__editPencilIcon___RVJLRl",
  "dX": "CustomStatusDisplay.module__editableEmojiOnly___RVJLRl",
  "qf": "CustomStatusDisplay.module__placeholder___RVJLRl",
  "Dm": "CustomStatusDisplay.module__placeholderIcon___RVJLRl",
  "RC": "CustomStatusDisplay.module__placeholderText___RVJLRl",
  "_C": "CustomStatusDisplay.module__emojiPressable___RVJLRl",
  "on": "CustomStatusDisplay.module__emojiTooltipTrigger___RVJLRl",
};

module.exports = exports;
